<template>
  <MenuItem v-bind="$attrs">
    <router-link :to="to">
      <slot />
    </router-link>
  </MenuItem>
</template>

<script>
  import MenuItem from './MenuItem'

  export default {
    components: {
      MenuItem,
    },
    
    props: {
      to: { type: Object, required: true }
    }
  }
</script>
